module.exports = __webpack_public_path__ + "img/titles2.0501e349.png";